import { selectionlistConfig } from '../../../../config';
import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { ErrorResponse, globalErrorResponse } from '../../../../store/notifications/actions';
import { setListSharedState } from '../../../../store/orderlist/actions';
import { http } from '../../../../api/axios';
import { invalidateSelectionListSummary } from '../../../../api/selection-list/useSelectionListSummary';

export interface SelectionListUpdateParams {
    shared: boolean;
    listName: string;
}

const updateSelectionList = (listId: string, data: SelectionListUpdateParams) => {
    const { shared, listName } = data;

    return http
        .put(
            selectionlistConfig().endpoint,
            { listName, shared },
            {
                pathParams: {
                    listId
                }
            }
        )
        .then(res => res.data);
};

export const useUpdateSelectionList = (listId: string) => {
    const dispatch = useDispatch();

    return useMutation<void, ErrorResponse, SelectionListUpdateParams>(params => updateSelectionList(listId, params), {
        onSuccess() {
            invalidateSelectionListSummary(listId).then();
        },
        onError: () => {
            dispatch(globalErrorResponse('Something went wrong with saving the selection list.'));
        }
    });
};

type ChangeListVisibility = { listId: string; shared: boolean; listName: string };
const changeListVisibility = (dto: ChangeListVisibility) => {
    const { listId, shared, listName } = dto;
    const pathParams = { listId };

    return http.put<void>(selectionlistConfig().endpoint, { listName, shared }, { pathParams }).then(res => res.data);
};

export const useChangeVisibility = () => {
    const dispatch = useDispatch();

    return useMutation<void, ErrorResponse, ChangeListVisibility, unknown>(changeListVisibility, {
        onSuccess(data, variables) {
            dispatch(setListSharedState(variables.shared));
        },
        onError: err => {
            dispatch(globalErrorResponse(err));
        }
    });
};
